module.exports = __webpack_public_path__ + "school/img/resource_display_bg.931cccee.jpg";